<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>Contact</h3>
    </fade-in-top-title>
    <div class="container">
      <router-view :user.sync="user"></router-view>
    </div>
  </main>
</template>

<script>
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';

export default {
  data() {
    return {
      user: {
        nameKanzi: "",
        nameKata: "",
        adress: "",
        tel: "",
        contents: ""
      }
    };
  },
  components: {
    FadeInTopTitle
  }
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  display: flex;
  justify-content: center;
}

.form-group {
  margin: 50px 0 15px;

  &:nth-child(1) {
    margin-right: 5px;
  }

  li {
    margin-bottom: 30px;
    text-align: right;
  }
}

.form-submit {
  margin-top: 10px;
}
</style>